import { render, staticRenderFns } from "./retornoOS.vue?vue&type=template&id=2b697698"
import script from "./retornoOS.vue?vue&type=script&lang=js"
export * from "./retornoOS.vue?vue&type=script&lang=js"
import style0 from "./retornoOS.vue?vue&type=style&index=0&id=2b697698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports